import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../index";
import * as shipBuilderSelectors from "./shipBuilderSelectors";
import * as optionalSystemsSelectors from "./optionalSystemsSelectors";
import * as derivedSelectors from "./derivedSelectors";
import * as shipSelectors from "./shipSelectors";
import * as uiSelectors from "./ui";

// Base selector
const selectShipBuilderState = (state: RootState) => state.shipBuilder;

// Group all selectors by feature
export const selectors = {
  shipBuilder: shipBuilderSelectors.selectors,
  optionalSystems: optionalSystemsSelectors.selectors,
  derived: derivedSelectors,
  ship: shipSelectors.selectors,
  ui: uiSelectors.selectors,
  stats: {
    selectTotalCost: createSelector(
      selectShipBuilderState,
      (state) => state.shipStats.totalCost,
    ),
    selectTotalWeight: createSelector(
      selectShipBuilderState,
      (state) => state.shipStats.totalWeight,
    ),
    selectPowerRequirements: createSelector(
      selectShipBuilderState,
      (state) => state.shipStats.powerRequirements,
    ),
    selectCargoSpace: createSelector(
      selectShipBuilderState,
      (state) => state.shipStats.cargoSpace,
    ),
    selectCrewRequirements: createSelector(
      selectShipBuilderState,
      (state) => state.shipStats.crewRequirements,
    ),
  },
  validation: {
    selectErrors: createSelector(
      selectShipBuilderState,
      (state) => state.validation.errors,
    ),
    selectWarnings: createSelector(
      selectShipBuilderState,
      (state) => state.validation.warnings,
    ),
  },
} as const;

// Re-export individual selector groups for convenience
export {
  shipBuilderSelectors,
  optionalSystemsSelectors,
  derivedSelectors,
  shipSelectors,
  uiSelectors,
};
